module.exports = __webpack_public_path__ + "img/mobile_banner.dcb7e1a8.jpg";